"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genCompactItemStyle = genCompactItemStyle;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
// handle border collapse
function compactItemBorder(token, options) {
  var childCombinator = options.borderElCls ? '> *' : '';
  var hoverEffects = ['hover', options.focus ? 'focus' : null, 'active'].filter(Boolean).map(function (n) {
    return "&:" + n + " " + childCombinator;
  }).join(',');
  return {
    '&-item:not(&-last-item)': {
      marginInlineEnd: -token.lineWidth
    },
    '&-item': (0, _extends4["default"])((0, _extends4["default"])((0, _defineProperty2["default"])({}, hoverEffects, {
      zIndex: 2
    }), options.focusElCls ? (0, _defineProperty2["default"])({}, "&" + options.focusElCls, {
      zIndex: 2
    }) : {}), (0, _defineProperty2["default"])({}, "&[disabled] " + childCombinator, {
      zIndex: 0
    }))
  };
}
// handle border-radius
function compactItemBorderRadius(prefixCls, options) {
  var _ref2;
  var childCombinator = options.borderElCls ? "> " + options.borderElCls : '';
  return _ref2 = {}, (0, _defineProperty2["default"])(_ref2, "&-item:not(&-first-item):not(&-last-item) " + childCombinator, {
    borderRadius: 0
  }), (0, _defineProperty2["default"])(_ref2, '&-item:not(&-last-item)&-first-item', (0, _defineProperty2["default"])({}, "& " + childCombinator + ", &" + prefixCls + "-sm " + childCombinator + ", &" + prefixCls + "-lg " + childCombinator, {
    borderStartEndRadius: 0,
    borderEndEndRadius: 0
  })), (0, _defineProperty2["default"])(_ref2, '&-item:not(&-first-item)&-last-item', (0, _defineProperty2["default"])({}, "& " + childCombinator + ", &" + prefixCls + "-sm " + childCombinator + ", &" + prefixCls + "-lg " + childCombinator, {
    borderStartStartRadius: 0,
    borderEndStartRadius: 0
  })), _ref2;
}
function genCompactItemStyle(token) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    focus: true
  };
  return (0, _defineProperty2["default"])({}, token.componentCls + "-compact", (0, _extends4["default"])((0, _extends4["default"])({}, compactItemBorder(token, options)), compactItemBorderRadius(token.componentCls, options)));
}